<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>View Asset</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="p-0">
  <mat-tab-group (selectedTabChange)="onTabChanged($event)">
    <mat-tab label="Details">
      <div class="container-fluid p-3">

        <div class="row">
          <div class="col-12 col-xl-6">
            <p><b>Name</b>: {{ asset.name }}</p>
            <p><b>Code</b>: {{ asset.code }}</p>
            <p><b>Type</b>: <span class="mr-2" *ngIf="asset.asset_type?.parent">{{ asset.asset_type?.parent?.name || '' }}</span> <span class="mr-1" *ngIf="asset.asset_type?.parent_id">&rarr;</span> {{ asset?.asset_type?.name }}</p>
            <p><b>Status</b>: <span [style.color]="assetsService.getStatusColor(asset.status) || null">{{  assetsService.getStatusLabel(asset.status) }}</span></p>
            <p><b>Condition Rating</b>: <span [style.color]="assetsService.getConditionColor(asset.condition_rating) || null">{{  assetsService.getConditionLabel(asset.condition_rating) }}</span></p>
            <p><b>Owner Type</b>: {{ assetsService.getOwnerTypeLabel(asset.owner_type) }}</p>

            <ng-container *ngIf="asset.owner_notes && assetsService.isNotOwned(asset.owner_type)">
              <p><b>Owner Notes</b>: <br><span class="multiline-text">{{ asset.owner_notes }}</span></p>
            </ng-container>

            <ng-container *ngIf="asset.location">
              <p><b>Location</b>: {{ asset.location }}</p>
            </ng-container>

            <ng-container *ngIf="asset.cost_amount">
              <p>
                <b>Cost Amount:</b>
                {{ assetsService.getCostAmountDisplay(asset.cost_amount, app.account.currency_code) || '' }}
              </p>
            </ng-container>

            <ng-container *ngIf="asset.cost_frequency && assetsService.isRecurringPayment(asset.owner_type)">
              <p><b>Billing Frequency</b>: {{ assetsService.getCostFrequencyLabel(asset.cost_frequency) }}</p>
            </ng-container>

            <ng-container *ngIf="asset.cost_start_at">
              <p>
                <b>{{ !assetsService.isRecurringPayment(asset.owner_type) ? 'Purchased' : 'Billing Start' }} Date:</b>
                {{ asset.cost_start_at | timezoneConvertMedium }}
              </p>
            </ng-container>

            <ng-container *ngIf="asset.cost_end_at && assetsService.isRecurringPayment(asset.owner_type)">
              <p>
                <b>Billing End Date:</b>
                {{ asset.cost_end_at | timezoneConvertMedium }}
              </p>
            </ng-container>

            <ng-container *ngIf="asset.description">
              <p><b>Description</b>: <br><span class="multiline-text">{{ asset.description }}</span></p>
            </ng-container>

            <ng-container *ngIf="asset.serial_no">
              <p><b>Serial Number</b>: {{ asset.serial_no }}</p>
            </ng-container>

            <ng-container *ngIf="asset.part_no">
              <p><b>Part Number</b>: {{ asset.part_no }}</p>
            </ng-container>

            <ng-container *ngIf="asset.purchase_order_no">
              <p><b>Purchase Order Number</b>: {{ asset.purchase_order_no }}</p>
            </ng-container>

            <ng-container *ngIf="asset.vehicle_reg_no">
              <p><b>Vehicle Registration Number</b>: {{ asset.vehicle_reg_no }}</p>
            </ng-container>

            <ng-container *ngIf="asset.noise_rating_db">
              <p><b>Noise Rating</b>: {{ asset.noise_rating_db }} dB</p>
            </ng-container>

            <ng-container *ngIf="asset.emissions_class">
              <p><b>Emissions Class</b>: {{ asset.emissions_class }}</p>
            </ng-container>

            <ng-container *ngIf="asset.expected_replacement_at">
              <p>
                <b>Expected Replacement Date:</b>
                <span [style.color]="assetsService.getDueDateColor(asset.expected_replacement_at, app.account.timezone) || null">
                  {{ asset.expected_replacement_at | timezoneConvertMedium }}
                </span>
              </p>
            </ng-container>

            <ng-container *ngIf="asset.warranty_expiry_date">
              <p>
                <b>Warranty Expiry Date:</b>
                <span [style.color]="assetsService.getDueDateColor(asset.warranty_expiry_date, app.account.timezone) || null">
                  {{ asset.warranty_expiry_date | timezoneConvertMedium }}
                </span>
              </p>
            </ng-container>

            <ng-container *ngIf="asset.maintenance_due_date">
              <p>
                <b>Maintenance Due Date:</b>
                <span [style.color]="assetsService.getDueDateColor(asset.maintenance_due_date, app.account.timezone) || null">
                  {{ asset.maintenance_due_date | timezoneConvertMedium }}
                </span>
              </p>
            </ng-container>

            <ng-container *ngIf="asset.next_inspection_due_date">
              <p>
                <b>Inspection Due Date:</b>
                <span [style.color]="assetsService.getDueDateColor(asset.next_inspection_due_date, app.account.timezone) || null">
                  {{ asset.next_inspection_due_date | timezoneConvertMedium }}
                </span>
              </p>
            </ng-container>

            <ng-container *ngIf="asset.last_inspection_at">
              <p>
                <b>Last Inspection At:</b> {{ (asset.last_inspection_at * 1000) | timezoneConvertLong }}
              </p>
            </ng-container>

            <ng-container *ngIf="asset.emergency_shutdown_procedure">
              <p><b>Emergency Shutdown Procedure</b>: <br><span class="multiline-text">{{ asset.emergency_shutdown_procedure }}</span></p>
            </ng-container>

            <ng-container *ngIf="asset.lifecycle_end_at && assetsService.isLifecycleEndStatus(asset.status)">
              <p><b>Lifecycle End Date</b>: {{ asset.lifecycle_end_at | timezoneConvertMedium }}</p>
            </ng-container>

            <ng-container *ngIf="asset.lifecycle_end_reason && assetsService.isLifecycleEndStatus(asset.status)">
              <p><b>Lifecycle End Reason</b>: <br><span class="multiline-text">{{ asset.lifecycle_end_reason }}</span></p>
            </ng-container>

            <ng-container *ngIf="asset.notes">
                <p><b>Notes</b>: <br><span class="multiline-text">{{ asset.notes }}</span></p>
            </ng-container>

            <ng-container *ngIf="asset?.site">
              <p>
                <b>{{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }} Name</b>: {{ asset.site.name }}<br>
                <b>{{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }} Address</b>: {{ asset.site.location }}
              </p>
            </ng-container>

            <ng-container *ngIf="asset?.contractor_owner && asset.owner_type == 'contractor_owned'">
              <p>
                <b>{{ utils.getLangTerm('contractors.singular', 'Contractor') }} Owner Name</b>: {{ asset.contractor_owner.name }}<br>
                <b>{{ utils.getLangTerm('contractors.singular', 'Contractor') }} Owner Industry</b>: {{ asset.contractor_owner.industry }}<br>
                <b>{{ utils.getLangTerm('contractors.singular', 'Contractor') }} Owner Main Contact</b>: <span *ngIf="asset.contractor_owner?.main_contact"><a (click)="onUserPublicView(asset.contractor_owner.main_contact.hash)" matTooltip="View User Public Profile">
                  {{ asset.contractor_owner.main_contact.contact_person }}
                </a></span>
              </p>
            </ng-container>

            <ng-container *ngIf="asset?.vendor">
              <p>
                <b>Vendor Name</b>: {{ asset?.vendor?.name }}<br>
                <b>Vendor Email</b>: <a *ngIf="asset?.vendor?.email" [href]="'mailto:' + asset?.vendor?.email" target="_blank">{{ asset?.vendor?.email }}</a><br>
                <b>Vendor Phone Number</b>: <a *ngIf="asset?.vendor?.phone_e164" [href]="'tel:' + asset?.vendor?.phone_e164" target="_blank">{{ asset?.vendor?.phone }}</a>
              </p>
            </ng-container>

            <p>
              <b>Created At</b>: {{ ((asset.date_created || 0) * 1000) | timezoneConvertMedium }}<br>
              <b>Created By</b>: <span *ngIf="asset?.created_by_user"><a (click)="onUserPublicView(asset.created_by_user.hash)" matTooltip="View User Public Profile">
                {{ asset.created_by_user.contact_person }}
              </a></span>
            </p>

            <p *ngIf="asset.date_modified">
              <b>Last Updated At</b>: {{ (asset.date_modified * 1000) | timezoneConvertMedium }}<br>
              <b>Last Updated By</b>: <span *ngIf="asset?.updated_by_user"><a (click)="onUserPublicView(asset.updated_by_user.hash)" matTooltip="View User Public Profile">
                {{ asset.updated_by_user.contact_person }}
              </a></span>
            </p>

          </div>

          <div class="col-12 col-xl-6">

            <div class="row">
              <div class="col-12 col-md-4">
                <ng-container>
                  <p class="d-flex align-items-center">
                    <b>Visible on Mobile app</b>:
                    <span [ngClass]="{'visible-yes': asset.is_visible, 'visible-no': !asset.is_visible}">
                      <mat-icon *ngIf="asset.is_visible" class="ml-2 mr-0 my-auto" style="font-size: 22px">visibility</mat-icon>
                      &nbsp;{{ asset.is_visible ? 'Yes' : 'No' }}
                    </span>
                  </p>
                </ng-container>
              </div>
              <div class="col-12 col-md-4">
                <ng-container>
                  <p class="d-flex align-items-center">
                    <b>Movable Asset</b>:
                    <span [ngClass]="{'mobile-yes': asset.is_mobile, 'mobile-no': !asset.is_mobile}">
                      <mat-icon *ngIf="asset.is_mobile" class="ml-2 mr-0 my-auto" style="font-size: 22px">directions_car</mat-icon>
                      &nbsp;{{ asset.is_mobile ? 'Yes' : 'No' }}
                    </span>
                  </p>
                </ng-container>
              </div>
              <div class="col-12 col-md-4">
                <ng-container>
                  <p class="d-flex align-items-center">
                    <b>Safety Critical</b>:
                    <span [ngClass]="{'safety-critical-yes': asset.is_safety_critical, 'safety-critical-no': !asset.is_safety_critical}">
                      <mat-icon *ngIf="asset.is_safety_critical" class="ml-2 mr-0 my-auto" style="font-size: 22px">warning</mat-icon>
                      &nbsp;{{ asset.is_safety_critical ? 'Yes' : 'No' }}
                    </span>
                  </p>
                </ng-container>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-12">
                <h6 class="text-center">Asset Image</h6>
              </div>
              <div class="col-12 text-center" *ngIf="asset.main_image_url">
                <app-image-preview-actions
                  [imageUrl]="asset.main_image_url"
                  imageClass="img-fluid border rounded p-1"
                  alt="Asset Main Image"
                  maxHeight="400px"
                  [downloadFileBaseName]="asset.main_image_name">
                </app-image-preview-actions>
              </div>
              <div class="col-12 text-center">
                <button mat-raised-button color="primary" type="button" (click)="onTriggerFileSelector($event)" *ngIf="!asset.main_image_url" class="my-1 mx-auto">
                  <mat-icon>image</mat-icon> Select &amp; Upload Image
                </button>
                <button mat-raised-button color="warn" type="button" (click)="onRemoveMainImage()" *ngIf="asset.main_image_url" class="my-1 mx-auto">
                  <mat-icon>delete</mat-icon> Remove Image
                </button>
                <input type="file" (change)="onUploadSelectedFile($event)" style="display: none;" #fileInput />
              </div>
              <div class="col-12 text-center" *ngIf="!asset.main_image_url">
                <mat-hint>Only image files are allowed.</mat-hint>
              </div>
            </div>

            <div class="row" *ngIf="asset?.qr_code">
              <div class="col-12 col-md-6 mb-2 text-center">
                <h6>QR Code</h6>
                  <app-image-preview-actions
                    [imageUrl]="asset.qr_code.code_url"
                    imageClass="img-fluid border rounded p-1"
                    alt="QR Code Image"
                    maxHeight="400px">
                  </app-image-preview-actions>
              </div>

              <div class="col-12 col-md-6 mb-2 text-center">
                <h6>Branded QR Code</h6>
                <app-image-preview-actions
                  [imageUrl]="asset.qr_code.code_branded_url"
                  imageClass="img-fluid border rounded p-1"
                  alt="Branded QR Code Image"
                  maxHeight="400px">
                </app-image-preview-actions>
              </div>
            </div>

            <div class="row">
              <div class="col-12 text-center">
                <button mat-raised-button color="secondary" type="button" (click)="onRegenerateQrCode()" class="my-1 mx-1">
                  <mat-icon>refresh</mat-icon> Regenerate QR Code
                </button>
                <button mat-raised-button color="secondary" type="button" (click)="onClaimQrCode()" class="my-1 mx-1">
                  <mat-icon>qr_code_2</mat-icon> Claim QR Code
                </button>
              </div>
            </div>

            <div class="row mt-3" *ngIf="asset.tags?.length">
              <div class="col-12">
                <h6>Tags</h6>
                <mat-chip-set role="list" aria-label="List of Tags">
                  <mat-chip role="listitem" *ngFor="let tag of asset.tags">{{ tag.title }}</mat-chip>
                </mat-chip-set>
              </div>
            </div>

          </div>

        </div>
      </div>
    </mat-tab>

    <mat-tab label="Files">
      <app-assets-view-files
        #assetsViewFilesComponent
        *ngIf="asset.id"
        [asset_id]="asset.id"
        [asset]="asset">
      </app-assets-view-files>
    </mat-tab>

    <mat-tab label="Contractors">
      <app-assets-view-contractors
        #assetsViewContractorsComponent
        *ngIf="asset.id"
        [asset_id]="asset.id"
        [asset]="asset">
      </app-assets-view-contractors>
    </mat-tab>

    <mat-tab label="Users">
      <app-assets-view-users
        #assetsViewUsersComponent
        *ngIf="asset.id"
        [asset_id]="asset.id"
        [asset]="asset">
      </app-assets-view-users>
    </mat-tab>

    <mat-tab label="Tasks">
      <app-assets-view-corrective-actions
        #assetsViewCorrectiveActionsComponent
        *ngIf="asset.id"
        [asset_id]="asset.id"
        [asset]="asset">
      </app-assets-view-corrective-actions>
    </mat-tab>

    <mat-tab label="Hazards & Risks">
      <app-assets-view-hazards
        #assetsViewHazardsComponent
        *ngIf="asset.id"
        [asset_id]="asset.id"
        [asset]="asset">
      </app-assets-view-hazards>
    </mat-tab>

    <mat-tab label="Safety Observations">
      <app-assets-view-safety-observations
        #assetsViewSafetyObservationsComponent
        *ngIf="asset.id"
        [asset_id]="asset.id"
        [asset]="asset">
      </app-assets-view-safety-observations>
    </mat-tab>

    <mat-tab label="Incidents">
      <app-assets-view-incidents
        #assetsViewIncidentsComponent
        *ngIf="asset.id"
        [asset_id]="asset.id"
        [asset]="asset">
      </app-assets-view-incidents>
    </mat-tab>

    <mat-tab label="Compliance Documents" *ngIf="asset.enable_compliance_documents">
      <!-- component -->
    </mat-tab>

    <mat-tab label="Usage Logs" *ngIf="asset.enable_usage_logs">
      <!-- component -->
    </mat-tab>

    <mat-tab label="Depreciation Logs" *ngIf="asset.enable_depreciation_logs">
      <!-- component -->
    </mat-tab>

    <mat-tab label="Repair History" *ngIf="asset.enable_repair_history">
      <!-- component -->
    </mat-tab>

    <mat-tab label="Maintenance Records" *ngIf="asset.enable_maintenance_records">
      <!-- component -->
    </mat-tab>

    <mat-tab label="Scheduled Maintenance" *ngIf="asset.enable_maintenance_records && asset.enable_schedules">
      <!-- component -->
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="px-2 py-1">

<!--  <button-->
<!--    mat-raised-button-->
<!--    class="my-2 ml-1 mr-2"-->
<!--    type="button"-->
<!--    color="secondary"-->
<!--    matTooltip="Click this button to open the events calendar."-->
<!--    (click)="onEventsCalendar()">-->
<!--    <mat-icon>event_repeat</mat-icon>-->
<!--    Events Calendar-->
<!--  </button>-->

  <div class="ml-lg-auto">
    <button
      mat-raised-button
      class="my-2 ml-1 mr-2"
      type="button"
      color="primary"
      aria-label="Share"
      matTooltip="Open this shareable link in a new tab"
      (click)="onOpenUrl(shareLink)"
    >
      <mat-icon>open_in_new</mat-icon>
      Share
    </button>

    <button
      mat-button
      type="button"
      ngxClipboard
      [cbContent]="shareLink"
      (click)="notifyCopied()"
      class="my-2 ml-1 mr-2"
      matTooltip="Copy link to clipboard">
      <mat-icon>file_copy</mat-icon>
      Copy Link
    </button>
  </div>
</mat-dialog-actions>

